module.exports = __webpack_public_path__ + "components/logo/static/cityspotters-5b99c81fac1b7ae244f7ad9bc9e9363a.svg";